import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      c1r() {
        throw SerializationException().w1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      d1r() {
        return true;
      }
      e1r() {
        return null;
      }
      f1r() {
        var tmp = this.c1r();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      g1r() {
        var tmp = this.c1r();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      h1r() {
        var tmp = this.c1r();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      i1r() {
        var tmp = this.c1r();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      j1r() {
        var tmp = this.c1r();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      k1r() {
        var tmp = this.c1r();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      l1r() {
        var tmp = this.c1r();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      m1r() {
        var tmp = this.c1r();
        return tmp instanceof Char() ? tmp.f4_1 : THROW_CCE();
      }
      n1r() {
        var tmp = this.c1r();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      o1r(enumDescriptor) {
        var tmp = this.c1r();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      p1r(descriptor) {
        return this;
      }
      q1r(deserializer, previousValue) {
        return this.r1r(deserializer);
      }
      s1r(descriptor) {
        return this;
      }
      t1r(descriptor) {
      }
      u1r(descriptor, index) {
        return this.f1r();
      }
      v1r(descriptor, index) {
        return this.g1r();
      }
      w1r(descriptor, index) {
        return this.h1r();
      }
      x1r(descriptor, index) {
        return this.i1r();
      }
      y1r(descriptor, index) {
        return this.j1r();
      }
      z1r(descriptor, index) {
        return this.k1r();
      }
      a1s(descriptor, index) {
        return this.l1r();
      }
      b1s(descriptor, index) {
        return this.m1r();
      }
      c1s(descriptor, index) {
        return this.n1r();
      }
      d1s(descriptor, index) {
        return this.p1r(descriptor.e1q(index));
      }
      e1s(descriptor, index, deserializer, previousValue) {
        return this.q1r(deserializer, previousValue);
      }
      g1s(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.b1n().q1p();
        var tmp;
        if (isNullabilitySupported || this.d1r()) {
          tmp = this.q1r(deserializer, previousValue);
        } else {
          tmp = this.e1r();
        }
        return tmp;
      }
    }
    protoOf($).f1s = decodeSerializableElement$default;
    protoOf($).r1r = decodeSerializableValue;
    protoOf($).i1s = decodeSequentially;
    protoOf($).k1s = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
